import { GridCellProps } from '@progress/kendo-react-grid';
import GridCellBase from 'src/components/GridCellBase';

const Period = (props: GridCellProps) => {
  const { dataIndex } = props;
  const value = (dataIndex as number) + 1;

  return (
    <GridCellBase {...props} className="!text-center" title={value.toString()}>
      <span>{value}</span>
    </GridCellBase>
  );
};

export default Period;
